/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminViewAsCompanyRequest
 */
export interface AdminViewAsCompanyRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminViewAsCompanyRequest
     */
    companyId: number;
}

/**
 * Check if a given object implements the AdminViewAsCompanyRequest interface.
 */
export function instanceOfAdminViewAsCompanyRequest(value: object): value is AdminViewAsCompanyRequest {
    if ((!('companyId' in (value as Record<string, any>)) && !('company_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['companyId'] === undefined && (value as Record<string, any>)['company_id'] === undefined)) return false;
    return true;
}

export function AdminViewAsCompanyRequestFromJSON(json: any): AdminViewAsCompanyRequest {
    return AdminViewAsCompanyRequestFromJSONTyped(json, false);
}

export function AdminViewAsCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminViewAsCompanyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
    };
}

export function AdminViewAsCompanyRequestToJSON(json: any): AdminViewAsCompanyRequest {
    return AdminViewAsCompanyRequestToJSONTyped(json, false);
}

export function AdminViewAsCompanyRequestToJSONTyped(value?: AdminViewAsCompanyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
    };
}

